/**
 * DevExtreme (esm/ui/scroll_view/ui.scrollable.js)
 * Version: 23.1.5
 * Build date: Wed Aug 30 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import Scrollable from "./ui.scrollable.old";
export default Scrollable;
